import React, { ComponentPropsWithRef, ReactElement } from 'react';
import classnames from 'classnames';
import { FormGroup, FormGroupText } from '../FormGroup';

export type NumberInputProps = ComponentPropsWithRef<'input'> & {
  error?: string;
  horizontal?: boolean;
  label?: string;
  labelClass?: string;
  required?: boolean;
};

export function NumberInput({
  className,
  error,
  horizontal = false,
  id,
  label,
  labelClass,
  required,
  ...rest
}: NumberInputProps): ReactElement {
  const classes = classnames({ error });

  return (
    <FormGroup
      horizontal={horizontal}
      errors={error ? [error] : []}
      className={className}
    >
      <FormGroupText>
        {label && (
          <label className={labelClass} htmlFor={id}>
            {label} {required && '*'}
          </label>
        )}
        <input id={id} type="number" className={classes} {...rest} />
      </FormGroupText>
    </FormGroup>
  );
}
